const MAX_TICKET_IMAGES = 3;

const getImageUrl = value => {
  if (typeof value === 'string') {
    return value.trim();
  }

  if (!value || typeof value !== 'object') {
    return '';
  }

  return String(
    value.url
    || value.downloadUrl
    || value.downloadURL
    || value.src
    || value.uri
    || value.img
    || ''
  ).trim();
};

const appendImages = (images, value) => {
  if (Array.isArray(value)) {
    value.forEach(item => appendImages(images, item));
    return;
  }

  if (value && typeof value === 'object' && !getImageUrl(value)) {
    Object.keys(value)
      .sort((left, right) => left.localeCompare(right, undefined, { numeric: true }))
      .forEach(key => appendImages(images, value[key]));
    return;
  }

  const url = getImageUrl(value);

  if (url && !images.includes(url)) {
    images.push(url);
  }
};

export const getTicketImages = ticket => {
  const source = ticket && typeof ticket === 'object' ? ticket : {};
  const images = [];

  [
    source.images,
    source.photos,
    source.imageUrls,
    source.photoUrls,
    source.img,
    source.image,
    source.photo,
    source.img1,
    source.img2,
    source.img3,
    source.image1,
    source.image2,
    source.image3,
    source.photo1,
    source.photo2,
    source.photo3,
    source.thumbnailUrl,
  ].forEach(value => appendImages(images, value));

  return images.slice(0, MAX_TICKET_IMAGES);
};

export { MAX_TICKET_IMAGES };
